import {observer} from "mobx-react";
import React from "react";
import ModalInformation from "@dropDesk/presentation/components/modals/modal_information";
import {useBetween} from "use-between";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import {useModalExtensions} from "@dropDesk/presentation/pages/extensions/ui/modals/handle_change_visible";
import {SharedColors} from "@dropDesk/domain/entities/theme/app_colors";

const ModalsExtensions = observer(
    ({
         onConfirmCancel,
         onConfirmReactivate,
         loading,
     }: {
        onConfirmCancel: (extensionId: string) => void,
        onConfirmReactivate: (extensionId: string) => void,
        loading: boolean,
    }) => {

        const {
            visibleModalCancelExtension,
            setVisibleModalCancelExtension,
            visibleModalReactivateExtension,
            setVisibleModalReactivateExtension,
            visibleModalCancelActivation,
            setVisibleModalCancelActivation,
        } = useBetween(useModalExtensions);

        return (
            <>
                <ModalInformation
                    open={visibleModalCancelExtension.visible}
                    onRequestClose={() => {
                        setVisibleModalCancelExtension({visible: false, extension: null});
                    }}
                    textHeaderModal={'Cancelar extensão'}
                    textButton={'Confirmar cancelamento'}
                    onRequestSave={async () => {
                        if (visibleModalCancelExtension.extension?.id) {
                            onConfirmCancel(visibleModalCancelExtension.extension.id);
                        }
                        setVisibleModalCancelExtension({visible: false, extension: null});
                    }}
                    nameIcon={ICONS_DROPDESK.warning}
                    iconColor={SharedColors.errorOnPrimary}
                    sizeIcon={115}
                    textInformation={
                        `A extensão continuará ativa até o fim do ciclo de cobrança atual. Após esse período, ela será desativada e não haverá mais cobranças.`
                    }
                    loading={loading}
                    isActionDelete={true}
                />
                <ModalInformation
                    open={visibleModalReactivateExtension.visible}
                    onRequestClose={() => {
                        setVisibleModalReactivateExtension({visible: false, extension: null});
                    }}
                    textHeaderModal={'Reativar extensão'}
                    textButton={'Reativar'}
                    onRequestSave={async () => {
                        if (visibleModalReactivateExtension.extension?.id) {
                            onConfirmReactivate(visibleModalReactivateExtension.extension.id);
                        }
                        setVisibleModalReactivateExtension({visible: false, extension: null});
                    }}
                    nameIcon={ICONS_DROPDESK.check}
                    sizeIcon={115}
                    textInformation={`O cancelamento agendado será removido e a extensão continuará ativa normalmente no próximo ciclo de cobrança.`}
                    loading={loading}
                    isActionDelete={false}
                />
                <ModalInformation
                    open={visibleModalCancelActivation.visible}
                    onRequestClose={() => {
                        setVisibleModalCancelActivation({visible: false, extension: null});
                    }}
                    textHeaderModal={'Cancelar ativação'}
                    textButton={'Cancelar ativação'}
                    onRequestSave={async () => {
                        if (visibleModalCancelActivation.extension?.id) {
                            onConfirmCancel(visibleModalCancelActivation.extension.id);
                        }
                        setVisibleModalCancelActivation({visible: false, extension: null});
                    }}
                    nameIcon={ICONS_DROPDESK.warning}
                    iconColor={SharedColors.errorOnPrimary}
                    sizeIcon={115}
                    textInformation={'Deseja cancelar a ativação desta extensão? Nenhum valor será cobrado e ela não será ativada na sua conta.'}
                    loading={loading}
                    isActionDelete={true}
                />
            </>
        );
    });

export default ModalsExtensions;
